let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f9SrL")).then(() => parcelRequire('mtjLb'));